import React, { useEffect, useState } from "react";
import LoadingSpinnerTable from "../../components/utilites/loader";
import ErrorPopup from "../../components/popups/ErrorPopup";
import {
  poCsvDownload,
  poList,
} from "../../redux/actions/purchaseOrderActions";
import { useDispatch } from "react-redux";
import moment from "moment";
import exportFromJSON from "export-from-json";
import PurchaseOrderViewModal from "../../components/modals/po/poViewModal";
import NumberPagination from "../../components/Pagination/number-pagination";

const PoTable = ({ search, page_no }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [poTableData, setpoTableData] = useState([]);
  const [showDetail, setShowDetail] = useState(false);
  const [selectedPoId, setPoSelected] = useState(null);
  const fileName = "report";
  const exportType = exportFromJSON.types.csv;

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    setLoading(true);
    fetchPoList();
  }, [page, search]);

  const fetchPoList = () => {
    dispatch(poList({ page, search }, onSuccess, onError));
  };
  const onSuccess = (data) => {
    setLoading(false);
    setpoTableData(data?.data?.data);
    console.log(data.data.data.pagination);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    console.log(err);
    setShowErrorPopup(true);
    const str = err.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  const csvUpload = (data) => {
    dispatch(
      poCsvDownload({ purchase_order_id: data }, onCsvSuccess, onCsvError)
    );
    console.log(data);
  };

  const onCsvSuccess = (data) => {
    console.log(data.data.data);
    const jsonArray = data.data.data?.map((item) => ({
      "PO Number": item?.po_number || "--",
      "PO Date": item?.po_date || "--",
      "Company Product ID": item?.company_product_id || "--",
      "Jivini Product ID": item?.product_id || "--",
      "Product Name": item?.product_name || "--",
      "Division Name": item?.division_name || "--",
      MRP: item?.mrp || "--",
      PTR: item?.ptr || "--",
      PTS: item?.pts || "--",
      "Doctor Code": item?.doctor_code || "--",
      "Doctor Name": item?.doctor_name || "--",
      "Pharmacy Code": item?.pharmacy_code || "--",
      "Pharmacy Name": item?.pharmacy_name || "--",
      "City Name": item?.city || "--",
      "Order ID": item?.order_id || "--",
      "Order Date": item?.order_date || "--",
      "Ordered Qty": item?.order_quantity || "--",
      "Ordered Free Qty": item?.order_free_quantity || "--",
      "Gross Value Of Order Qty@Ptr": item?.product_gross_value || "--",
      "Gross Value Of Order Free Qty@Ptr":
        item?.gross_value_of_ordered_free_qty_ptr || "--",
      "Gross Value Of Order Qty@Pts": item?.product_gross_value_pts || "--",
      "Gross Value Of Order Free Qty@Pts":
        item?.gross_value_of_ordered_free_qty_pts || "--",
      "Distributors Jivini Id": item?.distributor_code || "--",
      "Distributors Name": item?.distributor_name || "--",
      "Distributors Location": item?.distributor_location || "--",
      "Distributors Invoice Id": item?.distributor_invoice_id || "--",
      "Distributors Invoice Date": item?.distributor_invoice_date
        ? moment(item?.distributor_invoice_date).format("DD-MM-YYYY")
        : "--",
      "Distributors Invoiced Qty": item?.invoice_qty || "--",
      "Distributors Invoiced Free Qty": item?.invoice_free_qty || "--",
      "Supplied Ptr": item?.supplied_ptr || "--",
      "Gross Value Of Distributor Inv Qty@Ptr":
        item?.gross_value_of_dist_inv_qty_ptr || "--",
      "Gross Value Of Distributor Inv Free Qty@Ptr":
        item?.gross_value_of_dist_inv_free_qty_ptr || "--",
      "Gross Value Of Distributor Inv Qty@Pts":
        item?.gross_value_of_dist_inv_qty_pts || "--",
      "Gross Value Of Distributor Inv Free Qty@Pts":
        item?.gross_value_of_dist_inv_free_qty_pts || "--",
      "Gross Value Of Distributor Inv Qty@Supplied Ptr":
        item?.gross_value_of_dist_inv_qty_supplied_ptr || "--",
      "Gross Value Of Distributor Inv Free Qty@Supplied Ptr":
        item?.gross_value_of_dist_inv_free_qty_supplied_ptr || "--",
      "CFA Jivini Id": item?.distributor_cfa_name || "--",
      "CFA Name": item?.distributor_cfa_code || "--",
      "CFA Location": item?.distributor_cfa_location || "--",
      "CFA Inv No Reimbursement": item?.cfa_invoice_id || "--",
      "CFA Inv Date Reimbursement": item?.cfa_invoice_date
        ? moment(item?.cfa_invoice_date).format("DD-MM-YYYY")
        : "--",
      "Approval Linked Level 1 Name": item?.linked_level1_name || "--",
      "Approval Linked Level 1 Code": item?.linked_level1_code || "--",
      "Approval Linked Level 1 Mobile": item?.linked_level1_mobile || "--",
      "Approval Linked Level 2 Name": item?.linked_level2_name || "--",
      "Approval Linked Level 2 Code": item?.linked_level2_code || "--",
      "Approval Linked Level 2 Mobile": item?.linked_level2_mobile || "--",
    }));

    console.log(jsonArray, "jsonArrayjsonArray");
    exportFromJSON({ data: jsonArray, fileName, exportType });
  };

  const onCsvError = (err) => {
    console.log(err.data);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  const reimbursementOptions = {
    forward_cfa: "Full Order Forward from CFA",
    order_off_qty: "Order Offer Quantity",
    full_order_qty: "Full Order Quantity",
    credit_note: "Credit Note for Offer",
  };

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <>
      <div>
        <div className="table-container text-nowrap">
          <table className="main-table" style={{ position: "relative" }}>
            <thead>
              <tr className="table-rows">
                <th className="table-heads" width={"5%"}>
                  SL NO
                </th>
                <th className="table-heads " width={"10%"}>
                  Purchase Order ID
                </th>
                <th className="table-heads " width={"10%"}>
                  Distributor Name
                </th>
                <th className="table-heads " width={"10%"}>
                  Reimbursement Method
                </th>
                <th className="table-heads " width={"10%"}>
                  Generated Date(From)
                </th>
                <th className="table-heads " width={"10%"}>
                  Generated Date(To)
                </th>

                <th className="table-heads ps-4" width={"11%"}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody style={{ position: "relative" }}>
              {loading == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : poTableData?.purchaseOrder?.length > 0 ? (
                <>
                  {poTableData?.purchaseOrder?.map((item, index) => (
                    <tr className="table-rows1">
                      <td className="table-each-row-data">
                        {(poTableData?.pagination?.currentPage - 1) * 10 +
                          (index + 1)}
                      </td>
                      <td className="table-each-row-data">
                        {item?.code ? item?.code : "--"}
                      </td>
                      <td className="table-each-row-data text-capitalize">
                        {item.distributor?.firm_name
                          ? item.distributor?.firm_name
                          : "--"}
                      </td>
                      <td className="table-each-row-data text-capitalize">
                        {item?.reimbursement_method
                          ? reimbursementOptions[item?.reimbursement_method]
                          : "--"}
                        {/* {item?.offer_type
                          ? item?.offer_type.charAt(0).toUpperCase() +
                          item?.offer_type.slice(1)
                          : "--"} */}
                      </td>
                      <td className="table-each-row-data">
                        {item?.createdAt
                          ? moment(item?.createdAt).format(
                              "DD MMM YYYY HH:mm A"
                            )
                          : "--"}
                      </td>
                      <td className="table-each-row-data">
                        {item?.updatedAt
                          ? moment(item?.updatedAt).format(
                              "DD MMM YYYY HH:mm A"
                            )
                          : "--"}
                      </td>
                      <td className="table-each-row-data">
                        <label
                          className="color_2ad3e7 fw_700 cursor_pointer mx-1"
                          onClick={() => {
                            setPoSelected(item?.id);
                            setShowDetail(true);
                          }}
                        >
                          VIEW
                        </label>
                        <button
                          className="button-edit1 ps-0"
                          type="button"
                          onClick={() => csvUpload(item?.id)}
                        >
                          Download PO
                        </button>
                      </td>
                    </tr>
                  ))}
                </>
              ) : (
                <>
                  <tr>
                    <td
                      colSpan="1"
                      className="text-center no-data-container fs_16"
                    >
                      <span>~ No Data Found ~</span>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
        <div className={loading == true ? `loading-event` : ""}>
          {poTableData?.pagination?.totalPages > 0 && (
            <NumberPagination
              setCurrentPage={setPage}
              pagination={poTableData?.pagination?.currentPage}
              totalPages={poTableData?.pagination?.totalPages}
              path={"/purchase-order"}
              filters={`${queryString}`}
            />
          )}
        </div>
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
        {showDetail && (
          <PurchaseOrderViewModal
            poViewShow={showDetail}
            showClose={() => setShowDetail(false)}
            id={selectedPoId}
          />
        )}
      </div>
    </>
  );
};

export default PoTable;

const cfaListData = [
  {
    name: "sdf",
    age: "sfad",
    aaa: "fd",
  },
];
